import React from 'react';

export default props => {
    return ( 
        <svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg" onClick={props.onClick}>
            <g id="Bestill-rådgivning" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="bestill_radgiving-2-copy-5" transform="translate(-850.000000, -498.000000)" stroke={props.color || '#AAAAAA'} strokeWidth="2">
                    <g id="Group" transform="translate(851.000000, 498.000000)">
                        <path d="M0,1 L9,9.82233322" id="Page-1-Copy" transform="translate(4.500000, 5.411167) rotate(-270.000000) translate(-4.500000, -5.411167) "></path>
                        <path d="M9,9.82233322 L0,1" id="Page-1-Copy-3"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/images/RemoveIcon.js